/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The AreaOption model module.
* @module model/AreaOption
* @version 2020-12-7
*/
export default class AreaOption {
    /**
    * Constructs a new <code>AreaOption</code>.
    * エリア
    * @alias module:model/AreaOption
    * @class
    * @param id {Number} エリアID
    * @param name {String} エリア名
    */

    constructor(id, name) {
        
        
        this['id'] = id;
        this['name'] = name;
        
    }

    /**
    * Constructs a <code>AreaOption</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/AreaOption} obj Optional instance to populate.
    * @return {module:model/AreaOption} The populated <code>AreaOption</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AreaOption();
                        
            
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
        }
        return obj;
    }

    /**
    * エリアID
    * @member {Number} id
    */
    'id' = undefined;
    /**
    * エリア名
    * @member {String} name
    */
    'name' = undefined;




}
